import { useDeepCompareEffect, useFirstMountState } from 'react-use';
import { pick } from 'lodash';

import { ReceptionServiceFormController } from '../../../ReceptionServiceForm';
import { updateReceptionPractitionerWithDefaultConfiguration } from '../receptionServicePractitioner.utils';

type ReceptionServicePractitionersInteractiveTableSynchronizationProps = Pick<
   ReceptionServiceFormController,
   'watch' | 'getValue' | 'control' | 'setValue' | 'trigger'
>;

export const ReceptionServicePractitionersInteractiveTableSynchronization = (
   props: ReceptionServicePractitionersInteractiveTableSynchronizationProps
): null => {
   const firstMount = useFirstMountState();
   const receptionService = props.control.getValues();

   useDeepCompareEffect(() => {
      const practitioners = props.getValue('practitioners');
      if (!firstMount && practitioners?.value) {
         const updatedPractitioners = practitioners.value.map(
            updateReceptionPractitionerWithDefaultConfiguration(receptionService)
         );
         props.setValue('practitioners.value', updatedPractitioners);
      }
   }, [pick(receptionService, ['freeChecked', 'priceRangeChecked', 'price', 'priceRange', 'estimatedDuration'])]);

   return null;
};
